import React, {Component} from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import 'font-awesome/css/font-awesome.min.css';
import Mousetrap from 'mousetrap';
import {withRouter} from 'react-router-dom';
import {Button, ButtonToolbar, Col, Dropdown, MenuItem} from 'react-bootstrap';
import {getPreferredSettings, isPreferredSettings, nextIndex} from '../utils';
import {RoundCheckbox} from './RoundCheckbox';
import Confirmation from './Confirmation';
import SelectionNavContainer from '../containers/SelectionNavContainer';
import PresetsToolbarContainer from '../containers/PresetsToolbarContainer';
import includes from 'lodash/includes';
import size from 'lodash/size';
import findIndex from 'lodash/findIndex';
import debounce from 'lodash/debounce';
import {downloadDemoImage, printDemoImage} from '../actions/DemoActions';
import classNames from 'classnames';
import EditorCanvasContainer from '../containers/EditorCanvasContainer';
import ControlPanelContainer, {CONTROL_PANEL_WIDTH} from '../containers/ControlPanelContainer';
import TopNavContainer from '../containers/TopNavContainer';
import {isMac} from '../isMac';
import ReactTooltip from 'react-tooltip';
import DemoViewer from './DemoViewer';
import ImageNav from './ImageNav';

// todo: import these from styles css
const WORKSPACE_HEADER_HEIGHT = 40;

@withRouter
export default class Workspace extends Component {
    static propTypes = {
        srcPrefix: PropTypes.string,
        urlPrefix: PropTypes.string,
        galleryUrl: PropTypes.string,
        images: PropTypes.array,
        imageInfo: PropTypes.shape({
            src: PropTypes.string,
            previewSrc: PropTypes.string,
            poppedSrc: PropTypes.string,
            id: PropTypes.number,
            userId: PropTypes.any,
            amplitude: PropTypes.number,
            spread: PropTypes.number,
            poppedImageSrcPrefix: PropTypes.string,
        }),
        editHistory: PropTypes.shape({
            edits: PropTypes.array,
            lastDelete: PropTypes.string,
            lastDeleteTimeoutId: PropTypes.number,
            lastReset: PropTypes.array,
            lastResetTimeoutId: PropTypes.number,
            highlight: PropTypes.object,
        }),
        history: PropTypes.object,
        location: PropTypes.object,
        selectedImages: PropTypes.array,
        onSelect: PropTypes.func,
        onImageLoadError: PropTypes.func,
        onDelete: PropTypes.func,
        amplitude: PropTypes.number,
        spread: PropTypes.number,
        isOriginalActive: PropTypes.bool,
        activeImage: PropTypes.string,
        onImageViewerToggleOriginal: PropTypes.func.isRequired,
        onImageViewerSetPreferred: PropTypes.func,
        onImageViewerSelectionSetPreferred: PropTypes.func,
        onAmplitudeOrScaleChange: PropTypes.func,
        isDemo: PropTypes.bool,
        user: PropTypes.object,
        hasOpenModal: PropTypes.func,
        controlPanelSettings: PropTypes.object,
        width: PropTypes.number,
        height: PropTypes.number,
        onOpenFileUpload: PropTypes.func,
        prevId: PropTypes.number,
        nextId: PropTypes.number,
        currIdx: PropTypes.number,
        preventKeyNavigation: PropTypes.bool,
        onCloseImage: PropTypes.func,
    };

    static defaultProps = {
        urlPrefix: '',
        onImageLoadError: () => {
        },
        editHistory: {}
    };

    constructor(props) {
        super(props);

        this.gotToImageDebounced = debounce(this.gotToImage, 300);
    }

    componentDidMount() {
        Mousetrap.bind('space', (e) => {
            e.preventDefault();
            this.toggleOriginal();
        });
        Mousetrap.bind('esc', (e) => {
            e.preventDefault();
            if (!this.props.hasOpenModal()) {
                e.preventDefault();
                this.handleBackToGallery();
            }
        });
        Mousetrap.bind(['mod+del', 'mod+backspace'], (e) => {
            if (this.deleteConfirmation) {
                this.deleteConfirmation.openModal(e);
            }
        });
        Mousetrap.bind(['left'], (e) => {
            if (!this.props.preventKeyNavigation) {
                e.preventDefault();
                this.handlePrevImage();
            }
        });
        Mousetrap.bind(['right'], (e) => {
            if (!this.props.preventKeyNavigation) {
                e.preventDefault();
                this.handleNextImage();
            }
        });
        Mousetrap.bind('s', (e) => {
            e.preventDefault();
            this.handleSelect();
        });
        Mousetrap.bind('p', (e) => {
            e.preventDefault();
            this.handleSetPreferred();
        });
        Mousetrap.bind('mod+alt+p', (e) => {
            e.preventDefault();
            this.handleSelectionSetPreferred();
        });
        Mousetrap.bind('mod+s', (e) => {
            e.preventDefault();
            this.handleDownload();
        });
        Mousetrap.bind('mod+p', (e) => {
            e.preventDefault();
            this.handlePrint();
        });
        Mousetrap.bind('mod+o', (e) => {
            e.preventDefault();
            this.props.onOpenFileUpload();
        });
    }

    componentWillUnmount() {
        console.log('Unmounting Workspace');
        this.props.onCloseImage();
        // noinspection JSUnresolvedFunction
        Mousetrap.unbind(['space', 'esc', 'e', 's', 'p', 'mod+alt+p', 'mod+s', 'mod+p', 'mod+del', 'mod+backspace', 'mod+o']);
    }

    toggleOriginal = () => {
        this.props.onImageViewerToggleOriginal();
    };

    gotToImage = (id) => {
        this.props.history.push(`${this.props.urlPrefix}/image/${id}`);
    };

    handlePrevImage = () => {
        if (this.props.prevId) {
            this.gotToImageDebounced(this.props.prevId);
        }
    };

    handleNextImage = () => {
        if (this.props.nextId) {
            this.gotToImageDebounced(this.props.nextId);
        }
    };

    handleBackToGallery = () => {
        const galleryUrl = this.props.galleryUrl || `/images/${this.props.imageInfo.userId}`;
        this.props.history.push(galleryUrl);
    };

    handleDelete = () => {
        const {onDelete, imageInfo, images} = this.props;
        const count = size(images);
        onDelete(imageInfo);
        if (count === 1) {
            this.handleBackToGallery();
        } else {
            const currIdx = findIndex(images, ['id', imageInfo.id]);
            const nextIdx = nextIndex(currIdx, count);
            const nextId = images[nextIdx].id;
            this.gotToImage(nextId);
        }
    };

    handleSelect = () => {
        const {onSelect, imageInfo: {id, userId}} = this.props;
        onSelect(id, userId);
    };

    handlePrint = () => {
        const {isDemo, imageInfo, isOriginalActive} = this.props;
        if (isDemo) {
            printDemoImage(imageInfo, isOriginalActive);
            return;
        }
        this.canvasRef.getWrappedInstance().handlePrint();
    };

    handleDownload = () => {
        const {isDemo, imageInfo, isOriginalActive} = this.props;
        if (isDemo) {
            downloadDemoImage(imageInfo, isOriginalActive);
            return;
        }
        this.canvasRef.getWrappedInstance().handleDownload();
    };

    handleSetPreferred = () => {
        this.props.onImageViewerSetPreferred();
    };

    handleSelectionSetPreferred = () => {
        this.props.onImageViewerSelectionSetPreferred();
    };

    handleSwitchToPreferred = () => {
        const {imageInfo, user} = this.props;
        const {preferredAmplitude, preferredSpread} = getPreferredSettings(imageInfo, user);
        this.props.onAmplitudeOrScaleChange(imageInfo.id, {amplitude: preferredAmplitude, spread: preferredSpread});
    };

    setCanvasRef = (c) => {
        this.canvasRef = c;
    };

    renderEditor = (width, height) => {
        const {imageInfo, controlPanelSettings, editHistory: {edits, highlight}} = this.props;
        return (
            <EditorCanvasContainer
                width={width}
                height={height}
                imageInfo={imageInfo}
                focusOnMount={true}
                ref={this.setCanvasRef}
                controlPanel={controlPanelSettings}
                highlight={highlight}
                edits={edits}
                onToggleOriginal={this.toggleOriginal}
            />
        );
    };

    renderDemoViewer = (width) => {
        const {imageInfo, isOriginalActive, onImageLoadError} = this.props;
        return (
            <div style={{height: '100%', width}} onClick={this.toggleOriginal}>
                <DemoViewer
                    imageInfo={imageInfo}
                    onError={onImageLoadError}
                    isOriginalActive={isOriginalActive}
                />
            </div>
        );
    };

    handleResetView = () => {
        this.canvasRef.getWrappedInstance().resetView();
    };

    renderToolbar = () => {
        const {imageInfo, isDemo, selectedImages, preventKeyNavigation} = this.props;

        const selectionNav = (
            <SelectionNavContainer
                currentId={parseInt(imageInfo.id, 10)}
                isDemo={isDemo}
                selectedImages={selectedImages}
                preventKeyNavigation={preventKeyNavigation}
            />
        );

        const tooltips = [];
        const selectButton = (
            <div style={{width: 44, height: 32, float: 'left', padding: '6px 12px'}} data-tip data-for="selectTooltip">
                <RoundCheckbox size={20} onChange={this.handleSelect} checked={includes(selectedImages, imageInfo.id)}/>
            </div>
        );
        tooltips.push(
            <ReactTooltip id="selectTooltip" key="selectTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                <div>{'Toggle selection'}</div>
                <kbd>{'s'}</kbd>
            </ReactTooltip>
        );

        const printButton = (
            <Button bsStyle="link" onClick={this.handlePrint} data-tip data-for="printTooltip">
                <i className="fa fa-print"/>
            </Button>
        );
        tooltips.push(
            <ReactTooltip id="printTooltip" key="printTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                <div>{'Print'}</div>
                <kbd>{isMac ? 'cmd-p' : 'ctrl-p'}</kbd>
            </ReactTooltip>
        );
        const downloadButton = (
            <Button bsStyle="link" onClick={this.handleDownload} data-tip data-for="downloadTooltip">
                <i className="fa fa-download"/>
            </Button>
        );
        tooltips.push(
            <ReactTooltip id="downloadTooltip" key="downloadTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                <div>{'Save to my computer'}</div>
                <kbd>{isMac ? 'cmd-s' : 'ctrl-s'}</kbd>
            </ReactTooltip>
        );

        if (isDemo) {
            return (
                <ButtonToolbar className="pull-right workspace-toolbar">
                    {selectionNav}
                    {selectButton}
                    {printButton}
                    {downloadButton}
                    {tooltips}
                </ButtonToolbar>
            );
        }

        const {onOpenFileUpload, user, amplitude, spread} = this.props;
        const {preferredAmplitude, preferredSpread} = getPreferredSettings(imageInfo, user);
        const isPreferred = isPreferredSettings({amplitude, spread, preferredAmplitude, preferredSpread});
        const preferredButton = (
            <Dropdown className="preferred pull-right" id="preferred">
                <Button
                    bsStyle="link"
                    onClick={this.handleSetPreferred}
                    className={classNames({preferred: isPreferred})}
                    data-tip data-for="preferredTooltip"
                >
                    <i className="fa fa-thumbs-up"/>
                    <ReactTooltip id="preferredTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                        <div>{'Set as preferred'}</div>
                        <kbd>{'p'}</kbd>
                    </ReactTooltip>
                </Button>
                <Dropdown.Toggle/>
                <Dropdown.Menu>
                    <MenuItem
                        eventKey="11"
                        onClick={this.handleSetPreferred}
                    >
                        {`Set as preferred (a: ${amplitude}, s: ${spread}) `}<kbd className={'pull-right'}>{'p'}</kbd>
                    </MenuItem>
                    <MenuItem
                        eventKey="12"
                        onClick={this.handleSwitchToPreferred}
                    >
                        {`Switch to preferred preset (a: ${preferredAmplitude}, s: ${preferredSpread})`}
                    </MenuItem>
                    <MenuItem eventKey="13" onClick={this.handleSelectionSetPreferred} disabled={isEmpty(selectedImages)}>
                        <Confirmation
                            name="selectionSetPreferredModalConfirmation"
                            onConfirm={this.handleSelectionSetPreferred}
                            component="div"
                            componentLabel={<div>{' Set as preferred on all selected images'} <kbd className={'pull-right'}>{isMac ? 'cmd-alt-p' : 'ctrl-alt-p'}</kbd></div>}
                        >
                            {'Apply current preset as preferred on all selected images?'}
                        </Confirmation>
                    </MenuItem>
                </Dropdown.Menu>
            </Dropdown>
        );
        tooltips.push(
            <ReactTooltip id="preferredTooltip" key="preferredTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                <div>{'Set as preferred'}</div>
                <kbd>{'p'}</kbd>
            </ReactTooltip>
        );
        const uploadButton = (
            <Button bsStyle="link" onClick={onOpenFileUpload} data-tip data-for="uploadTooltip">
                <i className="fa fa-upload"/>
            </Button>
        );
        tooltips.push(
            <ReactTooltip id="uploadTooltip" key="uploadTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                <div>{'Open from my computer'}</div>
                <kbd>{isMac ? 'cmd-o' : 'ctrl-o'}</kbd>
            </ReactTooltip>
        );

        const deleteButton = (
            <Confirmation
                name="deleteConformationModal"
                bsStyle="link"
                onConfirm={this.handleDelete}
                componentLabel={
                    <i className="fa fa-trash"/>
                }
                ref={c => this.deleteConfirmation = c}
                data-tip data-for="deleteTooltip"
            >
                {`Delete ${imageInfo.fileName}?`}
            </Confirmation>
        );
        tooltips.push(
            <ReactTooltip id="deleteTooltip" key="deleteTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                <div>{'Delete'}</div>
                <kbd>{isMac ? 'cmd-delete' : 'ctrl-delete'}</kbd>
            </ReactTooltip>
        );

        tooltips.push(
            <ReactTooltip id="editTooltip" key="editTooltip" place="left" delayShow={400} className="light-tool-tip" type="light">
                <div>{'Edit'}</div>
                <kbd>{'e'}</kbd>
            </ReactTooltip>
        );

        return (
            <ButtonToolbar className="pull-right workspace-toolbar">
                {selectionNav}
                {selectButton}
                {preferredButton}
                {printButton}
                {downloadButton}
                {uploadButton}
                {deleteButton}
                {tooltips}
            </ButtonToolbar>
        );
    };

    render() {
        const {images, imageInfo, isDemo, user, editHistory, amplitude, spread, width, height, preventKeyNavigation, prevId, nextId, currIdx, history, urlPrefix} = this.props;
        const {preferredAmplitude, preferredSpread} = getPreferredSettings(imageInfo, user);

        const mainPanelWidth = width - CONTROL_PANEL_WIDTH;

        const col1 = isDemo ? {md: 2, sm: 2, xs: 1} : {md: 4, sm: 4, xs: 1};
        const col2 = isDemo ? {md: 8, sm: 8, xs: 7} : {md: 4, sm: 4, xs: 5};
        const col3 = isDemo ? {md: 2, sm: 2, xs: 4} : {md: 4, sm: 4, xs: 6};

        return (
            <div style={{height: '100%'}}>
                <div className="workspace">
                    <div className={classNames('workspace-main')}>
                        {isDemo ? this.renderDemoViewer(width) : this.renderEditor(mainPanelWidth, height - WORKSPACE_HEADER_HEIGHT)}
                    </div>
                    {!isDemo &&
                    <div className={classNames('workspace-sidebar')}>
                        <ControlPanelContainer
                            onResetView={this.handleResetView}
                            imageInfo={imageInfo}
                            editHistory={editHistory}
                            amplitude={amplitude}
                            spread={spread}
                            height={height}
                        />
                    </div>
                    }
                    <div className="workspace-header row-no-padding">
                        <Col {...col1}>
                            <ButtonToolbar className="workspace-toolbar">
                                <TopNavContainer isDropdownMenu={true}/>
                                <Button bsStyle="link" onClick={this.handleBackToGallery} data-tip data-for="backToGalleryTooltip">
                                    <i className="fa fa-th"/>
                                    <ReactTooltip id="backToGalleryTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                                        <div>{'Back to gallery'}</div>
                                        <kbd>{'esc'}</kbd>
                                    </ReactTooltip>
                                </Button>
                                <ImageNav
                                    imageInfo={imageInfo}
                                    prevId={prevId}
                                    nextId={nextId}
                                    currIdx={currIdx}
                                    imageCount={size(images)}
                                    history={history}
                                    preventKeyNavigation={preventKeyNavigation}
                                    urlPrefix={urlPrefix}
                                />
                            </ButtonToolbar>
                        </Col>
                        <Col {...col2} className="text-center">
                            {isDemo ?
                                <div className="space-toggle-hint">
                                    {'Click on the image or use '}<kbd>{'space'}</kbd>{' to switch between original and popped views'}
                                </div> :
                                <PresetsToolbarContainer
                                    preferredAmplitude={preferredAmplitude}
                                    preferredSpread={preferredSpread}
                                />
                            }
                        </Col>
                        <Col {...col3}>
                            {this.renderToolbar()}
                        </Col>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Workspace.js